var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","appear":"","appear-active-class":"fade-enter-active"}},[_c('div',[_vm._v(" В работе ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }